import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "@/pages/LandingPage";
import RsvpPage from "@/pages/RsvpPage";
import AdminPage from "@/pages/AdminPage";
import AdminGuestsPage from "@/pages/AdminGuestsPage";
import AdminSitePage from "@/pages/AdminSitePage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/rsvp" element={<RsvpPage />} />
          <Route path="/admin" element={<AdminPage />}>
            <Route index element={<Navigate to="guests" replace />} />
            <Route path="guests" element={<AdminGuestsPage />} />
            <Route path="site" element={<AdminSitePage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#301728",
            color: "#F2EEE7",
            border: "1px solid rgba(221, 191, 207,0.25)",
            fontFamily: "'AttributeMono', 'JetBrains Mono', monospace",
            fontSize: "12px",
            letterSpacing: "0.05em",
          },
        }}
      />
    </div>
  );
}

export default App;
